import React, { Component } from "react";
import Image from '../global/Image';
import { Link } from 'react-router-dom';

export default class CategoryContent extends Component {
	
	render () {
		
		let post 		= this.props.post;
				
		if (post) {
									
		    return (
			    
			    <div className={'c-post c-page__block c-page__block--load-effect'}>
			    
			    	<div className="l-content l-content--fixed-width">
			    		
			    		<div className="l-grid">
			    		
			    			{post.src &&
				    			<div className="l-grid__col">
				    				<div className="c-post__header-image">
				    					<Image srcset={post.srcset} src={post.src}></Image>
									</div>
				    			</div>
			    			}
			    		
			    			<div className="l-grid__col">
			    				<h2 className="c-post__heading" dangerouslySetInnerHTML={{__html:post.title}}></h2>
			    				<div className="c-rule"></div>
			    			</div>
			    		
			    			<div className="l-grid__col">
			    				
			    				<div className="c-blog__items">
					    			{post.post &&
						    			<>	
					    					{post.post.map((item,i) =>
												{	
													return (
														<div className="c-blog__items__item">
															<Link to={item.permalink} className="c-blog__items__item__inner">
																<div className="c-blog__items__item__image">
																	<Image srcset={item.srcset} src={item.src}></Image>
																</div>
																<h4 className="c-blog__items__item__heading" dangerouslySetInnerHTML={{__html:item.heading}}></h4>
																<div className="scope-text scope-text--faded" dangerouslySetInnerHTML={{__html:'<p>' + item.excerpt + '</p>'}}></div>
															</Link>
														</div>
													)
												}
											)}
										</>
									}
											
			    				</div>
			    				
			    			</div>
			    			
			    		</div>
			    		
			    	</div>
			    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
